import { Navigate, Route, Routes } from 'react-router-dom';

import { RoleKey } from 'modules/auth/core/enum';

import withRole from 'hooks/withRole';

import { PATH } from 'constants/path';

import { InstitutionInfoLayout } from './components/InstitutionInfoLayout';
import GeneralPage from './pages/GeneralPage';
import StationsPage from './pages/StationsPage';

const InstitutionInfoRoutes = () => {
  return (
    <Routes>
      <Route element={<InstitutionInfoLayout />}>
        <Route path={PATH.INSTITUTION_GENERAL} element={<GeneralPage />} />
        <Route path={PATH.INSTITUTION_STATIONS} element={<StationsPage />} />
        <Route index element={<Navigate to={PATH.INSTITUTION_GENERAL} />} />
      </Route>

      <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
    </Routes>
  );
};

export default withRole([RoleKey.INSTITUTION_ADMIN])(InstitutionInfoRoutes);
